<template>
<!-- <b-row class="ot-main-panel no-gutters">
    <b-col>
        <b-row>
            <b-col>
                <b-row  class=" no-gutters OT-content-header">
                    <b-col class="col-auto">
                        <b-nav>
                            <b-nav-item @click.prevent="toggleFilters()">
                                <otif-icon :icon="filterGlobalAction.name" :label="filterGlobalAction.label"/>
                            </b-nav-item>
                        </b-nav>
                    </b-col>
                    <b-col class="text-center OT-table-title">
                        <h1 class="text-center OT-table-title">Activity Dashboard</h1>
                        <select-dashboard/>
                    </b-col>
                    <b-col class="OTfixcenterfromRightSpace" cols="auto"></b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-col>
</b-row> -->
<activity-page/>
</template>


<script>

import ActivityPage from './ActivityPage.vue';

export default {

    computed: {
        connected() {
            return this.$store.state.socket.connected;
        },

        debug() {
            return process.env.NODE_ENV === 'development';
        },
    },

    components: {
        ActivityPage
    },

    data () {
        return {
            sidePanel: true,
            loaded: false,
            socketTimer: null,
            filterGlobalAction: {
                name: 'filter',
                label: 'Filters',
                callback: this.toggleFilters
            },
            showFilters : false,
            showEventModal : false
        }
    },

    methods: {
        

        onLoggedIn: function() {
            this.$store.commit('LOGGED_IN');
        },

        toggleFilters() {
            if (this.showFilters === true) {
                this.showFilters = false;
            } else {
                this.showFilters = true;
            }
        },


        
    },

    

    mounted() {
        
    },

    beforeRouteLeave(to, from, next) {
        this.$socket.sendObj({
            unSubscribe: ['components', 'activityFacets', 'activities']
        });
        this.$store.commit('components/CLEAR');
        if (to.hasOwnProperty('meta') && to.meta['ws'] !== true) {
            this.$socket.disconnect();
        }
        next();
    }
}

</script>
